export default "__VITE_ASSET__ZqFBvInB__"